import type { MessageC2W, MessageW2C } from "@/worker";
import { VortexClient } from "@client/index";

export default function (client: VortexClient, self: typeof window) {
	client.serviceWorker.addEventListener(
		"message",
		({ data }: { data: MessageW2C }) => {
			if (!("vortex$type" in data)) return;

			if (data.vortex$type === "cookie") {
				client.cookieStore.setCookies([data.cookie], new URL(data.url));
				const msg = {
					vortex$token: data.vortex$token,
					vortex$type: "cookie",
				};
				client.serviceWorker.controller.postMessage(msg);
			}
		}
	);

	client.Trap("Document.prototype.cookie", {
		get() {
			return client.cookieStore.getCookies(client.url, true);
		},
		set(ctx, value: string) {
			client.cookieStore.setCookies([value], client.url);
			const controller = client.descriptors.get(
				"ServiceWorkerContainer.prototype.controller",
				client.serviceWorker
			);
			if (controller) {
				client.natives.call("ServiceWorker.prototype.postMessage", controller, {
					vortex$type: "cookie",
					cookie: value,
					url: client.url.href,
				});
			}
		},
	});

	// @ts-ignore
	delete self.cookieStore;
}
